import { h, defineComponent } from 'vue';
import { box } from '@/ui/components';
import { CheckboxList, checklistEntry } from '@/ui/components/CheckboxList';
import { t } from '@/ui/i18n/i18n';

export const ChecklistSubscription = defineComponent({
  setup() {
    const checklist = [
      t('subscription.checklist.unlimited-inspections'),
      t('subscription.checklist.analytics'),
      t('subscription.checklist.permission-management'),
      t('subscription.checklist.report-customization'),
      t('subscription.checklist.scores'),
      t('subscription.checklist.categories-tags-labels'),
      t('subscription.checklist.notifications'),
      t('subscription.checklist.individual-templates'),
      t('subscription.checklist.report-export'),
    ].map(checklistEntry);

    return function render() {
      return box([
        h(CheckboxList, {
          props: {
            shadowed: true,
            list: checklist,
          },
        }),
      ], { class: 'subscribe_page__checklist' });
    };
  },
});
